import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import ProgrammeOfInquiry from "./routes/ProgrammeOfInquiry";
import SubjectGroupOverview from "./routes/SubjectGroupOverview";
import OtherInsightElements from "./routes/OtherInsightElements";
import Standards from "./routes/Standards";
import SGOTimeline from "./routes/SGOTimeline";
export default store => ({
  path: "verticalOverview/:subjectGroupId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "planning-insights" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return withDynamicUrlValidation({
          component,
          urlValidationType: "number",
        });
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    ProgrammeOfInquiry(store),
    SubjectGroupOverview(store),
    Standards(store),
    SGOTimeline(store),
    OtherInsightElements(store),
  ],
});
